import { Box, Button, ButtonGroup, DialogContent, FormGroup, IconButton, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableRow, Tabs, Typography, useTheme } from "@mui/material"
import { Delete, Edit, InfoRounded, NavigateNext, Save } from "@mui/icons-material";
import { TreeItem, TreeView } from "@mui/lab";
import React, { useState } from "react"
import { FormProvider, useForm } from "react-hook-form";
import useSWRImmutable from 'swr/immutable';
import { retrieveTipispedizione } from "../../api/tipospedizione";
import { creaTipiColli, eliminaTipiColli, mappaTipiColli, modificaTipiColli } from "../../api/ttipicolli";
import useBSSLogger from "../../hooks/useBSSLogger"
import __t from "../../lib/traduzioni";
import BSSAutocomplete from "../form/BSSAutocomplete";
import BSSNumber from "../form/BSSNumber";
import BSSText from "../form/BSSText"
import DefaultLoadingComponent from "../form/DefaultLoadingComponent";
import { CampiNum } from "../preventivo/Pacchi";
import BSSErrorBar from "../BSSErrorBar";
import { WaitKC } from "../Wrapper";
import BSSForm from "../form/BSSForm";
import { DefaultSubmitErrorHandler } from "../preventivo/Preventivo";
import { BSSDialogWithActions } from "../form/BSSDialog";
import DefaultErrorComponent from "../form/DefaultErrorComponent";
import BSSButton from "../form/BSSButton";

const {logger} = useBSSLogger();

const defaultCrudState = {openDialog: false, row: null, delete: false};

const Preferenze = ({}) => {

    return (
        <>            
            <WaitKC>
                <_Preferenze />
            </WaitKC>
            <BSSErrorBar />
        </>
    )
}

const _Preferenze = () => {         

    const [indiceSel, setIndiceSel] = useState("misurepredef")
    const theme = useTheme()
    
    const datiDefault = async () => {
        const tipiSpedizione = await retrieveTipispedizione();
        const misurePredef = await mappaTipiColli()

        logger.debug("dati di default per interfaccia misure predefinite preferenze", misurePredef)

        return {
            tipiSpedizione,
            misurePredef
        }
    }

    
    const {error, mutate: aggiornaMisurePredefinite, data} = useSWRImmutable("api/datiInizialiPreferenze", datiDefault)

    if(error){
        logger.debug("errore", error)
        return <DefaultErrorComponent {...{error}} />
    }
    
    if(!data && !error){
        return <DefaultLoadingComponent />
    }

    const {tipiSpedizione = [], misurePredef = []} = data;

    return(
        <>
            {/* <AppBar position="static"> */}
                <Tabs value={indiceSel} onChange={(e, newValue) => {
                        logger.debug("cambio tab", newValue)
                        setIndiceSel(newValue)
                    }} >
                    <Tab
                        value="misurepredef"
                        label={__t("misurepredef")}
                        wrapped                    
                    />
                    {/* <Tab value="two" label="Item Two" />
                    <Tab value="three" label="Item Three" /> */}
                </Tabs>
            {/* </AppBar> */}
            <Box p={2} mb={2}
                {...{
                    bgcolor: theme.palette.background.paper,
                    border: 2,                    
                    //borderRadius: 5,
                    borderColor: "primary.main",
                    borderTop: 0                  
                }}
                >
                {indiceSel === "misurepredef" && (
                    <>
                        <MisurePredefComp {...{tipiSpedizione, misurePredef, aggiornaMisurePredefinite}} />
                    </>
                )}
                {/* {indiceSel === "two" && (
                    <>
                        <div>
                            Item Two
                        </div>
                    </>
                )}
                {indiceSel === "three" && (
                    <>
                        <div>
                            Item Three 
                        </div>
                    </>
                )} */}
            </Box>
        </>
    )
}

const MisurePredefComp = ({tipiSpedizione, misurePredef, aggiornaMisurePredefinite}) => {


    const [crudState, setCrudState] = useState(defaultCrudState)
    const [mostraMisura, setMostraMisura] = useState(0)

    const toggleMostraMisura = id => {

        let nuovoid = 0;

        if(mostraMisura !== id){
            nuovoid = id;
        } 
        
        setMostraMisura(nuovoid)
    }

    const theme = useTheme()

    const listaMisurePredef = Object.values(misurePredef).reduce((arr, subarr) => [...arr, ...subarr], [])

    const elimina = async (righe) => {
        if(!Array.isArray(righe)){
            righe = [righe].map(riga => riga.id)
        }

        const eliminato = await eliminaTipiColli(righe);

        setCrudState(defaultCrudState);
        aggiornaMisurePredefinite()
    }

    const columnsMap = {
        tipoSpedizione: {
            field: "tipoSpedizione",
            headerName: __t("tipospedizione"),
            renderCell: (params) => {
                return (
                    params.value.descrizione
                )
            }
        },
        codice: {
            field: "codice",
            headerName: __t("codice")
        },
        ...CampiNum
            .filter(campo => campo.name !== "qta")
            .reduce((obj, campo) => ({...obj, [campo.name]: {
                field: campo.name,
                headerName: campo.label,
                type: "number",                                                
            }}), {}),
        azioni: {            
            field: "azioni",
            headerName: __t("azioniriga"),
            renderCell: (params) => {
                
                const {row} = params

                return (
                    <>
                        <ButtonGroup>
                            <Button key="button_delete" onClick={e => setCrudState({delete: true, openDialog: true, row})}>
                                <Delete color="error" />
                            </Button>
                            <Button key="button_edit" onClick={e => setCrudState({...defaultCrudState, openDialog: true, row})}>
                                <Edit color="primary" />
                            </Button>
                        </ButtonGroup>
                    </>
                )
            }
            
        }
    }

    /**
     * @type {import("@mui/x-data-grid").GridColDef[]}
     */
    const columns = Object.values(columnsMap).map(colonna => ({
        ...colonna,
        flex: 1,
        align: "right",
        disableReorder: true
    }))
    

    return (
        <>
            {/* <pre>{JSON.stringify(listaMisurePredef, null, 2)}</pre> */}
            
            {listaMisurePredef.length ? (
                <>                    

                    <Button fullWidth color="primary" variant="contained" onClick={e => setCrudState({...defaultCrudState, openDialog: true})}>
                        {__t("crea")}
                    </Button>


                    <div style={{minHeight: 250}}>
                        <TreeView style={{padding: "0px"}} expanded={listaMisurePredef.map(misura => misura.tipoSpedizione.descrizione)} >
                            {Object.keys(misurePredef)
                                .filter(tipoSpedizione => misurePredef[tipoSpedizione].length)
                                .sort((a, b) => {
                                    return a.localeCompare(b)
                                })
                                .map((tipoSpedizione, nodeId) => {
                                
                                const label = misurePredef[tipoSpedizione][0].tipoSpedizione.descrizione

                                const labelComp = (
                                    <>
                                        <Typography variant="h5">
                                            {label}
                                        </Typography>
                                    </>
                                )
                                
                                const misure = misurePredef[tipoSpedizione]

                                return (
                                    <TreeItem key={nodeId} {...{nodeId: label, label: labelComp}} icon={<NavigateNext />}>
                                        {misure
                                            .sort((a, b) => {
                                                return a.codice.localeCompare(b.codice)
                                            })
                                            .map(misura => {
                                            return (
                                                <TreeItem key={misura.codice} nodeId={misura.codice} label={(
                                                    <>
                                                        <Box display='flex'>
                                                            <Box>
                                                                <IconButton color="primary" onClick={e => toggleMostraMisura(misura.id)}>
                                                                    <InfoRounded />
                                                                </IconButton>
                                                            </Box>
                                                            <Box py={1.5} flexGrow={1}> 
                                                                {misura.codice} 
                                                            </Box>
                                                            <Box pt={0.75} pr={0.75}>
                                                                {columnsMap.azioni.renderCell({row: misura})}
                                                            </Box>
                                                        </Box>
                                                        {mostraMisura === misura.id && (
                                                            
                                                                <Box p={1}>
                                                                    <TableContainer component={Paper}  >            
                                                                        <Table>                                                                                    
                                                                            <TableBody>
                                                                                {CampiNum.filter(campo => campo.name !== "qta").map((campo, ixcampo) => {

                                                                                    const colonna = columnsMap[campo.name];
                                                                                    const label = colonna.headerName ?? colonna.field ?? "";
                                                                                    const value = misura[campo.name];
                                                                                    
                                                                                    return (
                                                                                        <TableRow key={ixcampo}>
                                                                                            <TableCell>
                                                                                                {label}
                                                                                            </TableCell>
                                                                                            <TableCell style={{textAlign: 'right'}}>
                                                                                                {value}
                                                                                            </TableCell>                                                                            
                                                                                        </TableRow>
                                                                                    )
                                                                                })}
                                                                        
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Box>
                                                            
                                                        )}
                                                    </>
                                                )}  />
                                            )
                                        })}
                                    </TreeItem>
                                )
                            })}
                            
                        </TreeView>
                        
                    </div>

                    <BSSDialogWithActions 
                        fullWidth 
                        maxWidth="xs" 
                        open={crudState.openDialog} 
                        closeHandler={e => setCrudState(defaultCrudState)} 
                        title={`${__t("misurepredef")} - ${crudState.delete ? __t("elimina") : crudState.row === null ? __t("creazione") : __t("modifica")}`}
                        actions={[
                            crudState.delete ? (
                                <Button key="btn_delete" variant="contained" autoFocus onClick={e => elimina(crudState.row)}
                                    style={{backgroundColor: theme.palette.error.main, color: theme.palette.common.white, fontWeight: "bolder"}} >
                                    {__t("elimina")}
                                </Button>
                            ) : "",
                            <Button key="btn_annulla" variant="contained" autoFocus onClick={e => setCrudState(defaultCrudState)}>
                                {__t("annulla")}
                            </Button>
                        ]}
                    >

                        <DialogContent>

                            {crudState.delete ? (
                                <>
                                    {__t("confermacancellazionemisurepredef")}
                                    <ul>
                                        <li>{crudState.row.codice}</li>
                                    </ul>
                                </>
                            ) : (
                                <>
                                    <FormNuovoTipoCollo {...{tipiSpedizione, setCrudState, crudState, aggiornaMisurePredefinite}} datiIniziali={crudState.row} />                                
                                </>
                            )}

                        </DialogContent>
                        
                    </BSSDialogWithActions>
                    
                </>
            ) : (
                <>
                    <FormNuovoTipoCollo {...{tipiSpedizione, aggiornaMisurePredefinite, crudState, setCrudState}} datiIniziali={crudState.row} />
                </>
            )}
            
        </>
    )
}

const FormNuovoTipoCollo = ({tipiSpedizione, datiIniziali, setCrudState, crudState, aggiornaMisurePredefinite}) => {

    const defaultValues = datiIniziali !== null ? datiIniziali : {};

    const methods = useForm({defaultValues})

    const onSubmitMisura = async (value) => {
        logger.debug("submit della misura di default", value);


        if(![null, undefined].includes(value.id)){
            const modificato = await modificaTipiColli(value);
            logger.debug("modificato tipo collo", modificato);
        } else {
            const nuovo = await creaTipiColli(value);
            logger.debug("creato nuovo tipo collo", nuovo);
        }

        setCrudState(defaultCrudState)
        aggiornaMisurePredefinite()
    }

    
    return (
        <>
            <FormProvider {...methods}>


                <BSSForm onSubmit={methods.handleSubmit(onSubmitMisura, DefaultSubmitErrorHandler)}>  

                    <FormGroup row>

                        <FormMisure {...{methods, tipiSpedizione}} />
                        
                        <Box width={1}
                                mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}} >

                            <BSSButton methods={methods} type="submit" style={{fontWeight: "bolder", height: "100%"}} variant="contained" color="primary" fullWidth >
                                <Save /> {__t("salva")}
                            </BSSButton>    
                        </Box>
                    </FormGroup>


                </BSSForm>

            </FormProvider>
        </>
    )
    
}

const FormMisure = ({methods, tipiSpedizione, readOnlyFields = []}) => {    
    
    return (
        <>

            <FormGroup row>

                {/* <Box width={{xs: 1, sm: 1, md: 1, lg: 3/14}}  */}
                <Box width={1}
                        mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}} >

                    <BSSText
                        name={`codice`} 
                        label={__t("codice")}    
                        methods={methods}
                        ControllerProps={{
                            rules: {
                                required: __t("validazione.requiredField", [__t("codice")])
                            }
                        }}
                    />
                </Box>

                {/* <Box width={{xs: 1, sm: 1, md: 1, lg: 2/14}}  */}
                <Box width={1}
                        mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}} >

                    {!readOnlyFields.includes("tipoSpedizione") === true && (                      
                        <BSSAutocomplete
                            name={`tipoSpedizione`} 
                            label={__t("tipospedizione")}    
                            methods={methods}
                            dataProvider={async () => tipiSpedizione}                                                        
                            AutocompleteProps={{
                                getOptionLabel: (option) => option.descrizione,
                                renderOption: (props, option, { selected }) =>(
                                    <li {...props}>
                                        {option.descrizione}
                                    </li>
                                )                
                            }}
                            TextFieldInputProps={{
                                readOnly: readOnlyFields.includes("tipoSpedizione"),
                            }}
                            ControllerProps={{
                                rules: {
                                    required: __t("validazione.requiredField", [__t("tipospedizione")])
                                }
                            }}
                        />
                    )}

                    
                </Box>


                {CampiNum.filter(campo => campo.name !== 'qta').map((campo, indiceCampo) => {

                    return (
                        // <Box width={{xs: 1, sm: 1, md: 1, lg: 2/14}} 
                        <Box width={1}
                            mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}} 
                            key={indiceCampo}
                            >

                            
                            <BSSNumber 
                                name={`${campo.name}`} 
                                label={`${campo.label}`}    
                                methods={methods}                                        
                            />  
                            
                        </Box>
                    )
                })}

            </FormGroup>
        </>
    )
}

export default Preferenze

export {FormMisure}